<template>
  <Basic>
    <router-view></router-view>
  </Basic>
</template>
